import { render, staticRenderFns } from "./ReportApprove.vue?vue&type=template&id=945dc2ac&scoped=true"
import script from "./ReportApprove.vue?vue&type=script&lang=js"
export * from "./ReportApprove.vue?vue&type=script&lang=js"
import style0 from "./ReportApprove.vue?vue&type=style&index=0&id=945dc2ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945dc2ac",
  null
  
)

export default component.exports